import type { WaterIntelRead } from './waterIntelTypes';

const MEMORY_TTL_MS = 5 * 60 * 1000;
const memory = new Map<string, { expiresAtMs: number; value: WaterIntelRead }>();

function bucketCoord(value: number, decimals = 2) {
  const p = 10 ** decimals;
  return Math.round(value * p) / p;
}

export function waterIntelClientCacheKey(lat: number, lng: number) {
  // Memory-only and deliberately coarse. Phase A does not persist exact inspected spots.
  return `${bucketCoord(lat)}:${bucketCoord(lng)}`;
}

export function readWaterIntelClientCache(key: string): WaterIntelRead | null {
  const hit = memory.get(key);
  if (!hit) return null;
  if (hit.expiresAtMs <= Date.now()) {
    memory.delete(key);
    return null;
  }
  return hit.value;
}

export function writeWaterIntelClientCache(key: string, value: WaterIntelRead) {
  memory.set(key, { value, expiresAtMs: Date.now() + MEMORY_TTL_MS });
}

export function clearWaterIntelClientCache() {
  memory.clear();
}
